<template>
  <v-container class="modern-detail-view pb-12">
    <!-- Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <v-btn icon @click="$router.go(-1)" class="mr-4 grey lighten-4 shadow-sm">
        <v-icon color="primary" small>fas fa-chevron-left</v-icon>
      </v-btn>
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white">fas fa-dolly-flatbed</v-icon>
        </v-avatar>
        <div>
          <div class="text-h4 font-weight-black primary--text lh-1">Registrar Movimientos</div>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest mt-1">Gestión manual de entradas, salidas y ajustes de stock</div>
        </div>
      </div>
      <v-spacer></v-spacer>
      <v-chip v-if="tipo" :color="tipo.in_out ? 'success' : 'error'" dark label class="font-weight-black px-4">
        <v-icon left x-small>{{tipo.in_out ? 'fas fa-arrow-right-to-bracket' : 'fas fa-arrow-right-from-bracket'}}</v-icon>
        {{tipo.in_out ? 'ENTRADA' : 'SALIDA'}}
      </v-chip>
    </v-row>
    <ValidationObserver v-slot="{handleSubmit}">
      <v-form @submit.prevent="handleSubmit(save)" ref="formulario">
        <!-- Configuration Card -->
        <v-card outlined class="modern-card shadow-sm pa-6 mb-8 mt-2">
          <div class="caption grey--text font-weight-black text-uppercase tracking-widest mb-6">Configuración del Movimiento</div>
          
          <v-row>  
            <v-col cols="12" md="4">
              <div class="caption grey--text font-weight-black text-uppercase mb-1 ml-1 px-1">Tipo de Movimiento</div>
              <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="tipo"
                  :items="tipos"
                  :loading="loading"
                  :disabled="loading"
                  item-text="name"
                  item-value="id"
                  placeholder="Seleccione un Tipo"
                  outlined
                  dense
                  return-object
                  :error-messages="errors"
                  class="modern-input"
                >
                  <template v-slot:item="data">
                    <div class="d-flex align-center">
                      <v-icon small :color="data.item.in_out ? 'success' : 'error'" class="mr-2">
                        {{data.item.in_out ? 'fas fa-arrow-right-to-bracket' : 'fas fa-arrow-right-from-bracket'}}
                      </v-icon>
                      <span class="caption font-weight-black">{{data.item.name}}</span>
                    </div>
                  </template>
                  <template v-slot:selection="data">
                    <div class="d-flex align-center">
                      <v-icon x-small :color="data.item.in_out ? 'success' : 'error'" class="mr-2">
                        {{data.item.in_out ? 'fas fa-arrow-right-to-bracket' : 'fas fa-arrow-right-from-bracket'}}
                      </v-icon>
                      <span class="caption font-weight-black title--text">{{data.item.name}}</span>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="4">
              <div class="caption grey--text font-weight-black text-uppercase mb-1 ml-1 px-1">Bodega / Almacén</div>
              <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                <v-select
                  v-model="store"
                  :items="stores"
                  :loading="loading"
                  :disabled="loading"
                  item-text="name"
                  item-value="id"
                  placeholder="Seleccione una Bodega"
                  outlined
                  dense
                  class="modern-input"
                  :error-messages="errors"
                  prepend-inner-icon="fas fa-warehouse"
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="4">
              <div class="caption grey--text font-weight-black text-uppercase mb-1 ml-1 px-1">Centro de Costo</div>
              <v-select
                v-model="center"
                :items="centers"
                :loading="loading"
                :disabled="loading"
                item-text="name"
                item-value="id"
                placeholder="Seleccione Centro de Costo"
                outlined
                dense
                class="modern-input"
                prepend-inner-icon="fas fa-location-arrow"
              />
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <div class="caption grey--text font-weight-black text-uppercase mb-1 ml-1 px-1">Referencia / Glosa</div>
              <v-text-field
                v-model='notes'
                placeholder="Ej: Factura #1234, Devolución..."
                outlined
                dense
                class="modern-input"
                hide-details
                prepend-inner-icon="fas fa-pen"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="tipo && tipo.id && tipo.in_out && tipo.price_effect">
              <div class="caption grey--text font-weight-black text-uppercase mb-1 ml-1 px-1">Vincular Orden de Compra</div>
              <add-purchase-order @add="addFromPurchaseOrder" :disabled="!store || !tipo"/>
            </v-col>
          </v-row>
        </v-card>

        <!-- Articles Manager Section -->
        <v-card outlined class="modern-card shadow-sm overflow-hidden mb-8">
          <v-sheet color="grey lighten-4" class="px-6 py-4 d-flex align-center border-bottom">
            <v-icon color="primary" x-small class="mr-2">fas fa-boxes-stacked</v-icon>
            <span class="caption font-weight-black uppercase tracking-widest grey--text">Selección de Artículos</span>
            <v-spacer></v-spacer>
            <div style="width: 400px">
              <add-article :disabled="!store || !tipo" @add="addArticle" />
            </div>
          </v-sheet>
        <!-- <v-row> 
          <v-col cols="12" md="8">
            <add-article :disabled="store==''&&tipo==''" @add="addArticle" />
          </v-col>
        </v-row> -->
          <v-scroll-x-transition>
            <div v-if="articles.length > 0">
              <v-simple-table class="modern-table">
                <thead>
                  <tr>
                    <th class="table-header-2">Artículo</th>
                    <th class="table-header-2 text-center">Unidad</th>
                    <th class="table-header-2">Ult. Compra</th>
                    <th class="table-header-2 text-center">Existencia</th>
                    <th class="table-header-2 text-center" style="width: 120px">Cantidad</th>
                    <th class="table-header-2 text-end" v-if="tipo && tipo.in_out && tipo.price_effect" style="width: 140px">Precio Unit.</th>
                    <th class="table-header-2 text-end" v-if="tipo && tipo.in_out && tipo.price_effect">Subtotal</th>
                    <th class="table-header-2 text-center" style="width: 80px">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in articles" :key="item.id">
                    <td>
                      <div class="d-flex flex-column">
                        <span class="caption font-weight-black primary--text lh-1 mb-1">[{{item.sku}}]</span>
                        <span class="body-2 font-weight-bold grey--text text--darken-4 text-truncate" style="max-width: 250px">{{item.name}}</span>
                      </div>
                    </td>
                    <td class="text-center font-weight-bold grey--text uppercase caption">{{item.unit_name}}</td>
                    <td>
                      <div v-if="item.last_buy" class="d-flex flex-column">
                        <span class="caption grey--text font-weight-bold">{{item.last_buy_date | moment("DD/MM/YYYY")}}</span>
                        <span class="caption primary--text font-weight-black">{{item.last_buy_price | moneda}}</span>
                      </div>
                      <span v-else class="caption font-italic grey--text text--lighten-1">Sin historial</span>
                    </td>
                    <td class="text-center">
                      <v-menu bottom left offset-y transition="slide-y-transition" content-class="modern-card existence-menu">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" class="existence-badge grey lighten-4 rounded px-2 py-1 pointer d-flex align-center justify-center">
                            <span class="caption font-weight-black primary--text mr-1">{{item.store_stock | number('0,0.00')}}</span>
                            <v-icon x-small color="grey">fas fa-chevron-down</v-icon>
                          </div>
                        </template>
                        <v-card flat class="pa-0">
                          <div class="px-4 py-2 border-bottom bg-lightgrey flex justify-space-between align-center">
                            <span class="caption font-weight-black uppercase tracking-widest grey--text text--darken-2">Stock por Bodega</span>
                          </div>
                          <v-simple-table dense class="modern-simple-table">
                            <tbody>
                              <tr v-for="register in item.stocks" :key="register.id">
                                <td class="caption">{{register.store_name}}</td>
                                <td class="text-end font-weight-black">{{register.qty | number('0,0.00')}}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-card>
                      </v-menu>
                    </td>
                    <td>
                      <v-text-field
                        v-model.number="item.qty"
                        type="number"
                        outlined dense hide-details
                        class="modern-input-small text-center"
                        :max="tipo.in_out ? 9000000 : item.store_stock"
                        :min="1"
                      />
                    </td>
                    <td v-if="tipo && tipo.in_out && tipo.price_effect">
                      <v-text-field
                        v-model.number="item.price"
                        type="number"
                        outlined dense hide-details
                        class="modern-input-small text-end"
                        prefix="$"
                      />
                    </td>
                    <td class="text-end font-weight-black primary--text" v-if="tipo && tipo.in_out && tipo.price_effect">
                      {{item.price * item.qty | moneda}}
                    </td>
                    <td class="text-center">
                      <div class="d-flex align-center justify-center gap-2">
                        <consume-by-o-t v-if="!tipo.in_out" :article="item" />
                        <v-btn icon x-small color="error" class="grey lighten-4" @click.stop="removeArticle(item)">
                          <v-icon x-small>fas fa-trash</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
            
            <div v-else class="pa-12 text-center bg-lightgrey">
              <v-icon size="64" color="grey lighten-3" class="mb-4">fas fa-cart-flatbed</v-icon>
              <div class="text-h6 grey--text font-weight-bold mb-1">No hay artículos seleccionados</div>
              <div class="caption grey--text uppercase tracking-widest">Utilice el buscador para agregar artículos al movimiento</div>
            </div>
          </v-scroll-x-transition>
        </v-card>

        <v-row v-if="articles.length > 0" class="mt-8">
          <v-col class="text-center">
            <v-btn 
              color="primary" 
              large 
              elevation="6"
              type="submit" 
              class="px-10 font-weight-black"
              :loading="loading"
            >
              <v-icon left>fas fa-save</v-icon>
              PROCESAR MOVIMIENTO
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>

    <!-- Progress Dialog (Standard Modern) -->
    <v-dialog v-model="showProgress" persistent max-width="400">
      <v-card class="modern-card pa-8 overflow-hidden">
        <div class="text-center">
          <v-progress-circular
            :rotate="360"
            :size="120"
            :width="12"
            :value="progress"
            color="primary"
            class="mb-6 font-weight-black"
          >
            {{ Math.round(progress) }}%
          </v-progress-circular>
          <div class="text-h6 font-weight-black primary--text">Registrando Inventario</div>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest mt-2">Por favor, no cierre esta ventana</div>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { fetchTipos, fetchStores,fetchCenters,updateStock,createStock,createTransaction,updateArticle,getArticle,updatePODetail} from '@/api/stocks'
import {createConsumptionBitacoraByOT} from '@/api/production'
import AddArticle from '@/components/stocks/AddArticle'
import AddPurchaseOrder from '@/components/stocks/AddPurchaseOrder'
import notifications from '@/utils/notifications'
import ConsumeByOT from '@/components/stocks/ConsumeByOT.vue'
export default {
  name:'CreateTransaction',
  components:{AddArticle,AddPurchaseOrder,ConsumeByOT},
  data() {
    return {
      loading: false,
      tipos:[],
      tipo:'',
      stores:[],
      store:'',
      centers:[],
      center:'',
      notes:'',
      articles:[],
      progress:'',
      showProgress:false,
    }
  },
  methods:{
    addConsume(item,payload){
      console.log(item)
      console.log(payload)
    },
    storeStock(item){
      const stock=item.stocks.filter(s=>s.store==this.store)
      if(stock.length==0) return {qty:0,id:-1}
      else return {qty: stock[0].qty,id:stock[0].id}
    },
    totalStock(item){
      return item.stocks.reduce((acc, val)=>{ return acc + val.qty}, 0)
    },
    addArticle(item){
      //Busco los stocks, el total y el ID del registro
      const storeStock=this.storeStock(item)
      item.store_stock=storeStock.qty
      item.store_stock_id=storeStock.id
      item.total_stock=this.totalStock(item)
      //Agrego la propiedad de consumo de bodega
      item.consume=[]
      //Chequeo si viene de una OC porque incluye ordered y received
      if(item.ordered){
        item.qty=item.ordered-item.received
        //If item qty es 0 no lo agrego a la lista porque 
        //debe estar todo recepcionado
        if(item.qty==0) return 0
      }
      else {
        item.qty=0
        item.price=0
      }
      const alreadyExist=this.articles.filter(a=>a.id==item.id).length
      if(alreadyExist<1){
        this.articles.push(item)
      }
    },
    addFromPurchaseOrder(item){
      this.notes='OC'+item.id+' '+item.title
      console.log(item.details)
      item.details.forEach(async i=>{
        await getArticle(i.article)
        .then(data=>{
          //Datos solo para la OC
          data.oc=item.id
          data.oc_detail=i.id
          data.ordered=i.qty
          data.received=i.received
          data.price=i.price
          this.addArticle(data)
        })
        .catch(err=>{throw err})
      })
    },
    removeArticle(item){
      this.articles=this.articles.filter(i=>i.id!=item.id)
    },
    async incoming(){
      this.showProgress=true
      this.progress=0
      const progressStep=100/this.articles.length
      //Registro de Entrada
      this.articles.forEach(async item=>{
        if(this.tipo.price_effect){
          // Calculo del precio promedio ponderado
          item.calculated_avg=(parseFloat(item.avg)*parseFloat(item.total_stock)+parseFloat(item.qty)*parseFloat(item.price))/(parseFloat(item.total_stock)+parseFloat(item.qty))
        }
        else{
          item.calculated_avg=item.avg
        }
        const transactionData={
          tipo: this.tipo.id,
          tarticle: item.id,
          store: this.store,
          qty: item.qty,
          price:parseFloat(item.price).toFixed(2),
          initial_qty: parseFloat(item.total_stock).toFixed(2),
          balance: (parseFloat(item.total_stock)+parseFloat(item.qty)).toFixed(2),
          initial_avg: parseFloat(item.avg).toFixed(2),
          calculated_avg: parseFloat(item.calculated_avg).toFixed(2),
          notes: this.notes,
        }
        await createTransaction(transactionData)
        .then(async (res)=>{
          const transactionId=res.id
          //Chequeo si el artículo existe en Bodega
          if(item.store_stock_id>-1){
            // Actualizo Inventario
            await updateStock(item.store_stock_id,{qty:parseFloat(item.store_stock)+parseFloat(item.qty)})
            .then(async (res)=>{
              // Actualizo precio del artículo
              const articleData={
                avg:parseFloat(item.calculated_avg).toFixed(2),
              }
              if(this.tipo.price_effect) articleData.last_buy=transactionId
              await updateArticle(item.id,articleData)
              .catch(err=>{
                notifications.showError('Error creando Actualizando Artículo '+err)
                return 0
              })
            })
            .catch(err=>{
              notifications.showError('Error creando Actualizando Stock '+err)
              return 0
            })
          }
          else{
            await createStock(
              {store:this.store,
              article:item.id,
              qty:parseFloat(item.store_stock)+parseFloat(item.qty)
              })
            .then(async res=>{
              // Actualizó el precio del artículo
              const articleData={
                avg:parseFloat(item.calculated_avg).toFixed(2),
              }
              if(this.tipo.price_effect) articleData.last_buy=transactionId
              await updateArticle(item.id,articleData)
              .catch(err=>{
                notifications.showError('Error creando Actualizando Artículo '+err)
                return 0
              })
            })
            .catch(err=>{
              notifications.showError('Error creando Creando Stock '+err)
              return 0
            })
          }
        })
        .catch(err=>{
          notifications.showError('Error creando Transacción '+err)
          return 0
        })
        if(item.oc){
          const received=parseFloat(item.received)+parseFloat(item.qty)
          await updatePODetail(item.oc_detail,{received})
          .then((res)=>console.log('Detalle Actualizado'))
          .catch(err=>{console.log('error actualizando detalle '+err)})
        }
        this.progress+=progressStep
        if(this.progress>=99.9){
          this.showProgress=false
          this.$router.replace('/stocks/success-transaction')
          
          return 0
        }
      })
    },
    outcoming(){
      //Valido si hay centro de costo seleccionado
      if(this.center==''){
        notifications.showError('Debe seleccionar un Centro de Costo')
        return 0
      }
      //Valido si los artículos poseen stock en bodega
      var errorExistencias=false
      this.articles.forEach(item=>{
        if(parseFloat(item.qty)>parseFloat(item.store_stock)){
          notifications.showError('Artículo '+'['+item.sku+'] '+item.name+ ' no posee existencias suficientes')
          errorExistencias=true
        }
      })
      if(errorExistencias) return 0

      this.showProgress=true
      this.progress=0
      const progressStep=100/this.articles.length

      //Creando las transacciones
      this.articles.forEach(async item=>{
        const transactionData={
          tipo: this.tipo.id,
          tarticle: item.id,
          store: this.store,
          qty: item.qty,
          price:parseFloat(item.avg).toFixed(2),
          initial_qty: parseFloat(item.total_stock).toFixed(2),
          balance: (parseFloat(item.total_stock)-parseFloat(item.qty)).toFixed(2),
          initial_avg: parseFloat(item.avg).toFixed(2),
          calculated_avg: parseFloat(item.avg).toFixed(2),
          notes: this.notes,
        }
        if(this.center) transactionData.center=this.center
        await createTransaction(transactionData)
        .then(async res=>{
          await updateStock(item.store_stock_id,{qty:(parseFloat(item.store_stock)-parseFloat(item.qty))})
          .catch(err=>{
            notifications.showError('Error creando Actualizando Stock '+err)
            return 0
          })
          
          //Obteniendo los datos de la transaccion
          const {id, tarticle } = res
          // Creando el registro de consumo por OT
          const {consume} = item

          const consume_data=consume.map(c=>({
              article_id:tarticle,
              workorder_id:c.work_order,
              articlePrice:parseFloat(item.avg),
              convertedPrice:parseFloat(item.avg)*(item.unit_consume_factor||1),
              qty:c.qty,
              unit:item.unit_name,
              unitConsume:item.unit_consume_name||item.unit_name,
              unitConsume_factor:item.unit_consume_factor||1
          }))

          await createConsumptionBitacoraByOT({'transaction_id':id,consume_data})
          .catch(err=>{
            notifications.showError('Error creando Consumo '+err)
            return 0
          })

          /* consume.forEach(async c=>{
            const consumeData={
              article_id:tarticle,
              transaction_id:id,
              workorder_id:c.work_order,
              articlePrice:parseFloat(item.avg),
              convertedPrice:parseFloat(item.avg)*(item.unit_consume_factor||1),
              qty:c.qty,
              unit:item.unit_name,
              unitConsume:item.unit_consume_name||item.unit_name,
              unitConsume_factor:item.unit_consume_factor||1
            }
            await createConsumptionBitacoraByOT(consumeData)
            .catch(err=>{
              notifications.showError('Error creando Consumo '+err)
            })
          }) */
          
          console.log(res)
        })
        this.progress+=progressStep
        if(this.progress>=100){
          this.showProgress=false
          this.$router.replace('/stocks/success-transaction') 
          return 0
        }
      })
    },
    save(){
      if (this.tipo.in_out) this.incoming()
      else this.outcoming()
    }
  },
  watch:{
    store(){
      this.articles=[]
    },
    tipo(){
      this.articles=[]
    }
  },
  async created(){
    this.tipos=await fetchTipos()
    this.stores=await fetchStores()
    this.centers=await fetchCenters()
  }
}
</script>

<style scoped>
.modern-detail-view { background-color: #f4f7f9; min-height: 100vh; }
.modern-card { border-radius: 12px !important; border: 1px solid rgba(0,0,0,0.05) !important; background-color: white !important; }
.shadow-sm { box-shadow: 0 2px 12px rgba(0,0,0,0.04) !important; }
.border-white-sm { border: 2px solid white !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.05) !important; }
.bg-lightgrey { background-color: #f8fbfc; }
.lh-1 { line-height: 1 !important; }
.gap-2 { gap: 8px; }
.uppercase { text-transform: uppercase; }
.tracking-widest { letter-spacing: 2px; }
.pointer { cursor: pointer; }

.modern-input >>> .v-input__control fieldset { border-radius: 8px !important; border-color: #e0e4e8 !important; }
.modern-input >>> .v-input__control { background-color: white !important; }

.modern-input-small >>> .v-input__control fieldset { border-radius: 4px !important; border-color: #e0e4e8 !important; }
.modern-input-small >>> input { font-size: 0.9rem !important; font-weight: 700 !important; color: #1a1f2e !important; }

.modern-table >>> .v-data-table-header th { white-space: nowrap; height: 52px !important; text-transform: uppercase; font-size: 0.65rem !important; letter-spacing: 1.5px; font-weight: 900 !important; background-color: #f8fbfc !important; color: #607d8b !important; }
.modern-table >>> td { padding: 12px 16px !important; border-bottom: 1px solid #f0f3f5 !important; }

.existence-badge { transition: all 0.2s; }
.existence-badge:hover { background-color: #e0e4e8 !important; }

.modern-simple-table >>> th { font-size: 0.65rem !important; text-transform: uppercase; letter-spacing: 1px; color: #78909c !important; }
.modern-simple-table >>> td { font-size: 0.75rem !important; height: 32px !important; }

.v-avatar.border-white-sm { border: 2px solid white !important; }
</style>